/* eslint-disable react/display-name */
/* eslint-disable @next/next/no-img-element */
"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { COUNTRIES } from "@/lib/country";
import { useState } from "react";

import { forwardRef } from "react";

export const SelectCountryPhone = forwardRef<
  HTMLButtonElement,
  {
    onChange: (value: string) => void;
    value?: string;
  }
>(({ onChange, value }, ref) => {
  const [code, setCode] = useState(value ?? "+62");

  const selected = COUNTRIES.find((country) => country.code === code);

  return (
    <>
      <Select
        onValueChange={(value) => {
          setCode(value);
          onChange(value);
        }}
      >
        <SelectTrigger
          className="w-24 border-none rounded-none"
          icon={false}
          ref={ref}
        >
          <div className="flex items-center space-x-2">
            <img
              className="w-4 h-3 shrink-0"
              src={"/flags/" + (selected?.code.toLowerCase() ?? "") + ".png"}
              alt={selected?.name ?? ""}
            />
            <SelectValue className="dark:text-theme-dark" placeholder={"+62"}>
              <span className="text-theme-gray">
                {selected?.dial_code ?? "-"}
              </span>
            </SelectValue>
          </div>
        </SelectTrigger>
        <SelectContent className="overflow-y-auto text-white bg-background dark:bg-theme-dark_card dark:border-theme-gray/20 dark:text-theme-dark border-theme-accent max-h-48">
          {COUNTRIES.map((country) => (
            <SelectItem
              key={country.code}
              value={country.code}
              className="pl-4"
              itemText={`${country.name} (${country.dial_code})`}
            >
              {country.dial_code}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="absolute right-0 inset-y-2 border-r border-[#E3E3E3] border-opacity-40"></div>
    </>
  );
});
